export function validateInputStringCoordinates (input) {
    const regex = /^-?\d{1,2}\.\d{3,19}, ?-?\d{1,3}\.\d{3,19}$/;
    if (regex.test(input)) {
        return true
    } else {
        return 'Coordenadas inválidas'
    };
};